import React from 'react';
import { 
  FaAmbulance, 
  FaBaby, 
  FaFemale, 
  FaHeartbeat, 
  FaHospital, 
  FaStethoscope, 
  FaSyringe, 
  FaUserMd,
  FaChevronRight,
  FaCalendarAlt,
  FaPhoneAlt,
  FaHeart,
  FaDna,
  FaProcedures,
  FaCheck,
  FaUsers,
  FaHandHoldingMedical
} from 'react-icons/fa';
import '../style.css';

const Facilities = () => {
  const facilities = [
    {
      icon: <FaAmbulance />,
      title: "Emergency Service 24 x 7",
      hindiTitle: "आकस्मिक सेवा 24 X 7",
      image: "https://th.bing.com/th/id/OIP.qwkpWK3Huew6XPc52LbEtwHaDM?o=7rm=3&rs=1&pid=ImgDetMain&o=7&rm=3",
      features: ["Advanced Life Support", "Trauma Care", "Emergency Surgery", "Critical Care Unit"]
    },
    {
      icon: <FaBaby />,
      title: "Comprehensive Pregnancy Treatment",
      hindiTitle: "गर्भा अवस्था का सम्पूर्ण ईलाज",
      image: "https://drshilpagb.in/wp-content/uploads/2024/05/High-Risk-Pregnancy-Treatment-in-bangalore.webp",
      subFacilities: [
        { title: "Normal Delivery", hindiTitle: "नार्मल व सिजेरियन डिलेवरी", icon: <FaBaby /> },
        { title: "High-Risk Maternity Center", hindiTitle: "हाई रिस्क प्रेगनेन्सी सेन्टर", icon: <FaHeartbeat /> },
        { title: "Pain-Free Childbirth", hindiTitle: "पीड़ा रहित प्रसव", icon: <FaHeart /> },
      ]
    },
    {
      icon: <FaFemale />,
      title: "Breast Care & Treatment",
      hindiTitle: "स्तन के विकार / गांठ का उपचार",
      image: "https://mkmovement.com.au/wp-content/uploads/2023/04/breast-cancer.png",
      features: ["Breast Cancer Screening", "Lump Evaluation", "Mammography", "Surgical Treatment"]
    },
    {
      icon: <FaProcedures />,
      title: "Menstrual Disorders Treatment",
      hindiTitle: "अनियमित व अत्याधिक मासिक रक्त स्त्राव का उपचार",
      image: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: ["Hormonal Therapy", "Medical Management", "Surgical Options", "Follow-up Care"]
    },
    {
      icon: <FaHospital />,
      title: "Non-Incisional Uterus Surgery",
      hindiTitle: "बच्चेदानी का बिना चीरा आपरेशन",
      image: "https://surgicarehospitals.com/wp-content/uploads/2023/06/DSC_5086.jpg",
      features: ["Hysteroscopy", "Myomectomy", "Polyp Removal", "Quick Recovery"]
    },
    {
      icon: <FaStethoscope />,
      title: "Laparoscopic Surgery Center",
      hindiTitle: "दूरबीन विधि द्वारा सभी आपरेशन",
      image: "https://www.indoreinfertilityclinic.com/wp-content/uploads/2013/10/LaparoscopicSurgery.jpg",
      subFacilities: [
        { title: "Uterine & Ovarian Cancer Care", hindiTitle: "बच्चेदानी व अण्डाशय के कैंसर का उपचार", icon: <FaUserMd /> }
      ]
    },
    {
      icon: <FaSyringe />,
      title: "Reproductive Health Services",
      image: "https://tse2.mm.bing.net/th/id/OIP.7ABQMt3juEQ8nTB_KE0TEQHaE8?rs=1&pid=ImgDetMain&o=7&rm=3",
      subFacilities: [
        { title: "Artificial Insemination (IUI)", hindiTitle: "कृत्रिम गर्भाधान (IUI)", icon: <FaSyringe /> },
        { title: "Fallopian Tube Recanalization", hindiTitle: "बच्चेदानी की नलियों को खोलने का आपरेशन", icon: <FaProcedures /> },
        { title: "Phototherapy", hindiTitle: "फोटोथेरिपी", icon: <FaDna /> }
      ]
    },
    {
      icon: <FaUsers />,
      title: "Planned Parenthood Services",
      hindiTitle: "फेमिली प्लानिंग सेवाएं",
      image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: ["Contraceptive Counseling", "Family Planning", "Birth Control Methods", "Postpartum Care"]
    },
    {
      icon: <FaHandHoldingMedical />,
      title: "Post-Surgical Care & Rehabilitation",
      hindiTitle: "शल्य चिकित्सा के बाद देखभाल और पुनर्वास",
      image: "https://tse1.explicit.bing.net/th/id/OIP.oy_mwQU69TTeUW0mOu0kcgHaE7?rs=1&pid=ImgDetMain&o=7&rm=3",
      features: ["Physical Therapy", "Wound Care", "Pain Management", "Recovery Monitoring"]
    }
  ];

  return (
    <div className="facilities-page">
      {/* Compact Header */}
      <div className="facilities-header">
        <div className="container">
          <div className="header-content">
            <div className="breadcrumb">
              <span>Home</span>
              <FaChevronRight />
              <span className="divider">–</span>
              <span className="current">Medical Facilities</span>
            </div>
            <h1>Our Medical Facilities</h1>
          </div>
        </div>
      </div>

      {/* Compact Facilities Grid */}
      <section className="facilities-grid-section">
        <div className="container">
          <div className="facilities-grid">
            {facilities.map((facility, index) => (
              <div key={index} className="facility-card-compact">
                <div className="facility-image-compact">
                  <img src={facility.image} alt={facility.title} />
                  <div className="facility-icon-compact">
                    {facility.icon}
                  </div>
                </div>
                
                <div className="facility-content-compact">
                  <h3>{facility.title}</h3>
                  {facility.hindiTitle && (
                    <p className="hindi-title-compact">{facility.hindiTitle}</p>
                  )}
                  
                  {facility.features && (
                    <div className="features-list-compact">
                      {facility.features.map((feature, idx) => (
                        <div key={idx} className="feature-item-compact">
                          <FaCheck /> {feature}
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {facility.subFacilities && (
                    <div className="sub-facilities-compact">
                      {facility.subFacilities.map((sub, idx) => (
                        <div key={idx} className="sub-facility-compact">
                          <span className="sub-icon-compact">{sub.icon}</span>
                          <div>
                            <strong>{sub.title}</strong>
                            {sub.hindiTitle && <div className="sub-hindi-compact">{sub.hindiTitle}</div>}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Compact Emergency CTA */}
      <section className="emergency-cta-compact">
        <div className="container">
          <div className="emergency-content-compact">
            <FaAmbulance className="emergency-icon-compact" />
            <div>
              <h3>24x7 Emergency Services</h3>
              <p>Immediate medical attention</p>
            </div>
            <div className="emergency-buttons-compact">
              <button className="emergency-btn-compact"><FaPhoneAlt /> Call</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Facilities;